import {noop} from '@sail/utils';
import {createContext} from 'react';

export default createContext<(name: string) => () => void>(() => noop);
